import React from 'react';
import Container from 'container';
import Headline from 'headline';
import s from './black_banner.module.scss';

export default function AdA({ title, subtitle, text, ...props }) {
  return (
    <Container className={s.root}>
      <div className={s.wrapper}>
        <Headline className={s.title} h1 center white html={title} />
        <p className={s.subtitle} dangerouslySetInnerHTML={{ __html: subtitle }} />
        <p className={s.text} dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </Container>
  );
}


